import React, { useState, useEffect, useCallback, useMemo  } from "react";
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Input,
  Label,
  FormGroup,
  Card,
  CardBody,
  CardTitle,
  Pagination,
  PaginationItem,
  PaginationLink,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
import { getAuthUser } from "../../../helpers/utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import * as url from "../../../helpers/url_helper";
import { updateDocumentJson, reviewedDocumentJson } from "../../../slices/AIDoc/thunk";
import { toast } from "react-toastify";
import { fetchUsers } from "../../../slices/thunks";
import Select from "react-select";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const hideFields = {
  document_info: [
    "document_status_normalized",
    "current_version",
    "is_parent_promulgation",
    "gazette_missing_date_flag",
    "gazette_inferred_date_note",
    "publication_page",
    "publication_section",
    "document_external_references",
    "document_hierarchy",
    "validation",
    "section_map",
    "document_actions",
    "ai_explanation",
    "attachments"
  ],
  premable: [
    "chunk_type"
  ],
  articles: [
    "chunk_id",
    "chunk_type",
    "article_title_ar",
    "article_actions_embedding",
    "is_source_article",
    "Replaced_info"
  ],
  annexes: [
    "annex_id",
    "annex_number",
    "language",
    "annex_status",
    "issuing_authority_ar",
    "document_reference_ar",
    "bbox",
  ]
};

/**
 * Recursive editor component:
 * - Renders primitive values as inputs/textareas
 * - Renders objects and arrays recursively
 * - Calls onChange(path, newValue) where path is array of keys/indexes
 */
// function RecursiveEditor ({ value = '', path = [], onChange, name, keys, readOnly = false }) {
//   const { t } = useTranslation();
//   const isObject = value && typeof value === "object" && !Array.isArray(value);
//   const isArray = Array.isArray(value);

//   const handlePrimitiveChange = (newVal) => {
//     onChange(path, newVal);
//   };

//   if (isObject) {
//     const objectKeys = keys ? Object.keys(value).filter((k) => !keys.includes(k)) : Object.keys(value);

//     return (
//       <div style={{ borderLeft: "2px solid #eee", paddingLeft: 12, marginBottom: 8 }}>
//         {name && <div style={{ fontWeight: 600, marginBottom: 6 }}>{t(name)}</div>}
//         {objectKeys.map((key) => (
//           <RecursiveEditor
//             keys={keys}
//             name={key}
//             value={value[key]}
//             path={[...path, key]}
//             onChange={onChange}
//             readOnly={readOnly}
//           />
//         ))}
//       </div>
//     );
//   } else if (isArray) {
//     return (
//       <div style={{ borderLeft: "2px dashed #eee", paddingLeft: 12, marginBottom: 8 }}>
//         <div style={{ fontWeight: 600, marginBottom: 6 }}>
//           {t(name)} ({t('length')}: {value.length})
//         </div>
//         {value.map((item, idx) => (
//           <div key={idx} style={{ marginBottom: 8 }}>
//             <RecursiveEditor
//               name={`[${idx}]`}
//               value={item}
//               path={[...path, idx]}
//               onChange={onChange}
//               keys={keys}
//               readOnly={readOnly}
//             />
//             <div>
//               <Button
//                 size="sm"
//                 color="danger"
//                 outline
//                 onClick={() => {
//                   const newArr = [...value];
//                   newArr.splice(idx, 1);
//                   onChange(path, newArr);
//                 }}
//               >
//                 {t('Remove')}
//               </Button>
//             </div>
//           </div>
//         ))}
//         <div style={{ marginTop: 6 }}>
//           <Button
//             size="sm"
//             color="primary"
//             outline
//             onClick={() => {
//               const newArr = [...value, typeof value[0] === "object" ? {} : ""];
//               onChange(path, newArr);
//             }}
//           >
//             {t('Add')}
//           </Button>
//         </div>
//       </div>
//     );

//   } else if (name === "IsReplaced" && !value) {
//     return null
  
//   } else {
  
//     // primitive value
//     const asString = value === null ? "" : String(value);
//     // const useTextarea =
//     //   asString.length > 120 || asString.includes("\n") || /[اأإآ]/.test(asString);

//     const useTextarea =
//       asString.length > 120 || asString.includes("\n");

//     return (
//       <FormGroup style={{ marginBottom: 8 }}>
//         <Label style={{ fontWeight: 600, fontSize: 14 }}>{t(name)}</Label>
//         {useTextarea ? (
//           <Input
//             type="textarea"
//             value={asString}
//             rows={5}
//             onChange={(e) => handlePrimitiveChange(e.target.value)}
//             readOnly={readOnly}
//           />
//         ) : (
//           <Input
//             type="text"
//             value={asString}
//             onChange={(e) => handlePrimitiveChange(e.target.value)}
//             readOnly={readOnly}
//           />
//         )}
//       </FormGroup>
//     );
//   }
// }

function RecursiveEditor({ value = '', path = [], onChange, name, keys, readOnly = false }) {
  const { t } = useTranslation();
  const isObject = value && typeof value === "object" && !Array.isArray(value);
  const isArray = Array.isArray(value);

  const handlePrimitiveChange = (newVal) => {
    onChange(path, newVal);
  };

  // 🧭 Pagination state for "articles"
  const [pageIndex, setPageIndex] = useState(0);

  // Helper to compute visible pages (like your annexPagination)
  const paginationPages = useMemo(() => {
    const total = isArray ? value.length : 0;
    const current = pageIndex;
    const maxVisible = 7;
    const pages = [];

    if (total <= 1) return [];

    pages.push(0);
    if (total <= maxVisible) {
      for (let i = 1; i < total; i++) pages.push(i);
      return pages;
    }

    let start = Math.max(1, current - 2);
    let end = Math.min(total - 2, current + 2);
    const windowSize = maxVisible - 2;

    if (end - start + 1 < windowSize) {
      if (current <= Math.floor(total / 2)) {
        end = Math.min(total - 2, start + windowSize - 2);
      } else {
        start = Math.max(1, end - windowSize + 1);
      }
    }

    if (start > 1) pages.push("ellipsis-left");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 2) pages.push("ellipsis-right");

    pages.push(total - 1);
    return pages;
  }, [value, pageIndex, isArray]);

  if (isObject) {
    const objectKeys = keys ? Object.keys(value).filter((k) => !keys.includes(k)) : Object.keys(value);
    return (
      <div style={{ borderLeft: "2px solid #eee", paddingLeft: 12, marginBottom: 8 }}>
        {name && <div style={{ fontWeight: 600, marginBottom: 6 }}>{t(name)}</div>}
        {objectKeys.map((key) => (
          <RecursiveEditor
            key={key}
            keys={keys}
            name={key}
            value={value[key]}
            path={[...path, key]}
            onChange={onChange}
            readOnly={readOnly}
          />
        ))}
      </div>
    );
  }

  else if (isArray) {
    if (name === "articles") {
      const total = value.length;
      const currentArticle = value[pageIndex] || {};

      return (
        total ?
        <div style={{ borderLeft: "2px dashed #ccc", paddingLeft: 12, marginBottom: 8 }}>
          <div className="d-flex justify-content-between">
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              {t(name)} ({t('length')}: {total})
            </div>

            <div>
              <Button
                size="sm"
                color="secondary"
                outline
                onClick={() => {
                  // add new blank article
                  const newArticles = 
                    [...(value || []), { 
                      article_number: "",
                      article_number_numeric: "",
                      article_title_ar: "",
                      content: "",
                      is_source_article: "",
                      group_type: [],
                      article_actions: [],
                      article_linking: []
                    }]

                  handlePrimitiveChange(newArticles);
                  setPageIndex(newArticles.length - 1);
                }}
              >
                {t('Add')}
              </Button>
            </div>
          </div>

          <RecursiveEditor
            // name={`Article #${pageIndex + 1}`}
            value={currentArticle}
            path={[...path, pageIndex]}
            onChange={onChange}
            keys={keys}
            readOnly={readOnly}
          />

          <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 12 }}>
            <Pagination>
              <PaginationItem disabled={pageIndex === 0}>
                <PaginationLink previous onClick={() => setPageIndex((p) => p - 1)} />
              </PaginationItem>

              {paginationPages.map((p, idx) =>
                p === "ellipsis-left" || p === "ellipsis-right" ? (
                  <PaginationItem key={idx} disabled>
                    <PaginationLink>...</PaginationLink>
                  </PaginationItem>
                ) : (
                  <PaginationItem active={p === pageIndex} key={idx}>
                    <PaginationLink onClick={() => setPageIndex(p)}>
                      {p + 1}
                    </PaginationLink>
                  </PaginationItem>
                )
              )}

              <PaginationItem disabled={pageIndex === total - 1}>
                <PaginationLink next onClick={() => setPageIndex((p) => p + 1)} />
              </PaginationItem>
            </Pagination>

          </div>

          <div className="d-flex justify-content-end">
            <Button
              size="sm"
              color="danger"
              outline
              onClick={() => {
                // remove current article
                const arr = [...value];
                arr.splice(pageIndex, 1);
               
                handlePrimitiveChange(arr);
                setPageIndex(Math.max(0, pageIndex - 1));
              }}
            >
              {t('Delete')}
            </Button>
          </div>
        </div> : null
      );
    }

    // 🧱 Default array rendering (non-"articles")
    return (
      <div style={{ borderLeft: "2px dashed #eee", paddingLeft: 12, marginBottom: 8 }}>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>
          {t(name)} ({t('length')}: {value.length})
        </div>
        {value.map((item, idx) => (
          <div key={idx} style={{ marginBottom: 8 }}>
            <RecursiveEditor
              name={`[${idx}]`}
              value={item}
              path={[...path, idx]}
              onChange={onChange}
              keys={keys}
              readOnly={readOnly}
            />
            {!readOnly && (
              <div>
                <Button
                  size="sm"
                  color="danger"
                  outline
                  onClick={() => {
                    const newArr = [...value];
                    newArr.splice(idx, 1);
                    onChange(path, newArr);
                  }}
                >
                  {t('Remove')}
                </Button>
              </div>
            )}
          </div>
        ))}
        {!readOnly && (
          <div style={{ marginTop: 6 }}>
            <Button
              size="sm"
              color="primary"
              outline
              onClick={() => {
                const newArr = [...value, typeof value[0] === "object" ? {} : ""];
                onChange(path, newArr);
              }}
            >
              {t('Add')}
            </Button>
          </div>
        )}
      </div>
    );
  }

  else if (name === "IsReplaced" && !value) {
    return null;
  }

  else {
    const asString = value === null ? "" : String(value);
    const useTextarea = asString.length > 60 || asString.includes("\n");

    return (
      <FormGroup style={{ marginBottom: 8 }}>
        <Label style={{ fontWeight: 600, fontSize: 14 }}>{t(name)}</Label>
        {useTextarea ? (
          <Input
            type="textarea"
            value={asString}
            rows={5}
            onChange={(e) => handlePrimitiveChange(e.target.value)}
            readOnly={readOnly}
          />
        ) : (
          <Input
            type="text"
            value={asString}
            onChange={(e) => handlePrimitiveChange(e.target.value)}
            readOnly={readOnly}
          />
        )}
      </FormGroup>
    );
  }
}

/**
 * Helper: update nested value immutably given a path (array of keys/indexes)
 */
function updateAtPath(obj, path, newValue) {
  if (path.length === 0) {
    return newValue;
  }
  const [head, ...rest] = path;
  let clone;
  if (Array.isArray(obj)) clone = [...obj];
  else if (obj && typeof obj === "object") clone = { ...obj };
  else {
    clone = typeof head === "number" ? [] : {};
  }

  clone[head] = updateAtPath(clone[head], rest, newValue);
  return clone;
}

/**
 * Main app
 */
const DocumentDetails = () => {
  const { t, i18n } = useTranslation();
  const { user } = getAuthUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { state = {} } = useLocation();
  
  const [isSaving, setIsSaving] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showReviewed, setShowReviewed] = useState(false);
  const [data, setData] = useState({});
  const [activeTab, setActiveTab] = useState("document");
  const [openAccordion, setOpenAccordion] = useState(["2"]);
  const [paraLegalIDs, setParaLegalIDs] = useState(state.ParaLegalIDs || []);
  const [selectedInstrumentType, setSelectedInstrumentType] = useState(null);

  const [preambleIndex, setPreambleIndex] = useState(0);
  const [articleIndex, setArticleIndex] = useState(0);
  const [memorandumIndex, setMemorandumIndex] = useState(0);
  const [annexIndex, setAnnexIndex] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const [newTypeName, setNewTypeName] = useState("");

  const selectedDoc = data || {};
  const validationSchema = Yup.object().shape({
    ParaLegalIDs: Yup.array().of(Yup.string()).nullable(),
  });

  const { Users, Loading } = useSelector((state) => ({
    Users: state.Users.users,
    Loading: state.Users.loading
  }));

  const toggleAccordion = (id) => {
    if (openAccordion.includes(id)) {
      setOpenAccordion(openAccordion.filter((x) => x !== id));
    } else {
      setOpenAccordion([...openAccordion, id]); // multiple open allowed
    }
  };

  const onChangeValue = (path, newVal) => {
    const parsedVal = attemptParsePrimitive(newVal);
    const updated = updateAtPath(data, [...path], parsedVal);
    setData(updated);

    // trigger debounced save
    if (user.RoleID == 118) {
      debouncedSave(updated);
    }
  };

  function attemptParsePrimitive(v) {
    // keep strings by default; but if user typed 'true'/'false'/'null'/'123' we might parse
    if (v === null) return null;
    if (typeof v !== "string") return v;
    const trimmed = v.trim();
    if (trimmed === "") return "";
    if (trimmed === "null") return null;
    if (trimmed === "true") return true;
    if (trimmed === "false") return false;
    if (!isNaN(Number(trimmed)) && trimmed.length < 16) {
      return Number(trimmed);
    }
    return v;
  }

  // helper to update top-level fields (document_type etc.)
  const updateDocumentField = (fieldPath, newValue) => {
    const updated = updateAtPath(data, [...fieldPath], newValue);
    setData(updated);

    // trigger debounced save
    if (user.RoleID == 118) {
      debouncedSave(updated);
    }
  };

  // export JSON
  const exportJSON = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = state.FileName?.replace('.pdf', '.json') || 'documents.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleReviewDocument = async () => {
    setShowReviewed(false);
    setIsSaving(true);
    try {
      const response = await handleSaveJson(data, true, 4);
      // dispatch(reviewedDocumentJson({ DocID: state.DocID, IsSaved: true }))
      // await reviewedDocument({ DocID: state.DocID });
    } catch (error) {
      console.log('error: ', error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleSaveJson = async (data, pushToPinecone = false, status = state.Status) => {
    if (isSaving) return;

    setIsSaving(true);
    try {
      const payload = {
        DocID: state.DocID,
        JsonURL: state.JsonURL,
        DocumentTypeID: state.DocumentTypeID,
        Status: status,
        pushToPinecone: pushToPinecone,
        documents: data
      }

      // data.DocID = state.DocID;
      // data.JsonURL = state.JsonURL;
      // data.DocumentTypeID = state.DocumentTypeID;
      // data.Status = [1, 4, 98].includes(user.RoleID) ? 3 : state.Status;
      // data.pushToPinecone = pushToPinecone;

      // const formData = new FormData();
      // formData.append("payload", payload);

      const response = await fetch(url.SAVE_DOC_DETAILS, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        // headers: { 'Content-Type': "text/plain" },
        body: JSON.stringify(payload), 
      });

      if (!response.body) throw new Error("No response body for stream");

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      // Process streaming response
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split("\n\n");
        buffer = events.pop(); // keep last incomplete chunk

        for (const eventBlock of events) {
          if (!eventBlock.trim()) continue;

          let eventName = "";
          let eventData = "";

          for (const line of eventBlock.split("\n")) {
            if (line.startsWith("event:"))
              eventName = line.slice(6).trim();
            else if (line.startsWith("data:"))
              eventData += line.slice(5).trim();
          }

          if (!eventName || !eventData) continue;

          try {
            const parsedData = JSON.parse(eventData);

            if (eventName === "error") {
              throw new Error('Something Went Wrong')
            }

            if (eventName === "file_saved") {
              // ✅ Update state safely
              if (state.JsonURL != parsedData.url) {
                state.JsonURL = parsedData.url;
                state.IsProcessed = true;
                state.ParaLegalIDs = paraLegalIDs;
                state.Status = status;

                await dispatch(updateDocumentJson(state)).unwrap()
                if (pushToPinecone) {
                  await dispatch(reviewedDocumentJson({ DocID: state.DocID, IsSaved: true })).unwrap()
                }

                navigate('/ai/document-details', { 
                  state:  {
                    ...state
                  },
                  replace: true
                })
              } else {
                toast.success(t("DocumentDetailsSavedMessage"));
              }
              return parsedData;
            }
          } catch (err) {
            toast.error(t('Something Went Wrong'));
            console.warn("Invalid SSE event data:", eventData, err);
          }
        }
      }
    } catch (error) {
      console.error("Save stream error:", error);
    } finally {
      setIsSaving(false); // ✅ only after stream fully ends
    }
  }

  const debouncedSave = useCallback(
    debounce(handleSaveJson, 3000), // shorter debounce feels snappier
    [state.JsonURL] // correct deps
  );

  const allArticles = selectedDoc?.articles || [];

  const filteredArticles = useMemo(() => {
    if (!selectedInstrumentType) return allArticles;
    return allArticles.filter(a => a.instrument_type === selectedInstrumentType);
  }, [allArticles, selectedInstrumentType]);

  // Article pagination helpers
  // const articles = selectedDoc?.articles || [];
  const articleCount = filteredArticles.length;
  const currentArticle = filteredArticles[articleIndex] || null;

  // Premable pagination helpers
  const preamble = selectedDoc?.sections?.document_preamble || [];
  const preambleCount = preamble.length;
  const currentPreamble = preamble[preambleIndex] || null;

  // Annexes pagination helpers
  const annexes = selectedDoc?.sections?.annexes || [];
  const annexCount = annexes.length;
  const currentAnnex = annexes[annexIndex] || null;

  // Memorandum pagination helpers
  const memorandum = selectedDoc?.sections?.document_explanatory_memorandum || [];
  const memorandumCount = memorandum?.length;
  const currentMemorandum = memorandum[memorandumIndex] || null;

  const gotoPreamble = (idx) => {
    const newIdx = Math.max(0, Math.min(preambleCount - 1, idx));
    setPreambleIndex(newIdx);
  };

  const gotoArticle = (idx) => {
    const newIdx = Math.max(0, Math.min(articleCount - 1, idx));
    setArticleIndex(newIdx);
  };

  const gotoAnnex = (idx) => {
    const newIdx = Math.max(0, Math.min(annexCount - 1, idx));
    setAnnexIndex(newIdx);
  };

  const gotoMemorandum = (idx) => {
    const newIdx = Math.max(0, Math.min(memorandumCount - 1, idx));
    setMemorandumIndex(newIdx);
  };

    const handleEditClick = (e, type) => {
    e.stopPropagation();
    setEditingType(type);
    setNewTypeName(type);
    setIsModalOpen(true);
  };

  const handleEditSave = () => {
    if (!newTypeName.trim()) return;
  
    setData(prev => ({
      ...(prev || {}),
      articles: (allArticles || []).map(article =>
        article.instrument_type === editingType
          ? { ...article, instrument_type: newTypeName }
          : article
      ),
    }));

    setIsModalOpen(false);
    setEditingType(null);
    setNewTypeName(null);
  };


  const instrumentTypes = useMemo(() => {
    const types = (selectedDoc?.articles || [])
      .map(a => a.instrument_type)
      .filter(Boolean); // remove empty
    return [...new Set(types)];
  }, [selectedDoc?.articles]);

  const preamblePagination = useMemo(() => {
    const total = preambleCount;       // total pages
    const current = preambleIndex;     // current page index (0-based)
    const maxVisible = 7;             // max pages to display in window
    const pages = [];

    if (total <= 1) return [];
    // if (total <= 1) return null;

    // Always include first page
    pages.push(0);

    // Case 1: if total pages ≤ maxVisible → showDelete all
    if (total <= maxVisible) {
      for (let i = 1; i < total; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Define sliding window
    let start = Math.max(1, current - 2);
    let end = Math.min(total - 2, current + 2);

    // Ensure window always has (maxVisible - 2) slots (excluding first & last)
    const windowSize = maxVisible - 2;
    if (end - start + 1 < windowSize) {
      if (current <= Math.floor(total / 2)) {
        end = Math.min(total - 2, start + windowSize - 2);
      } else {
        start = Math.max(1, end - windowSize + 1);
      }
    }

    // Left ellipsis
    if (start > 1) {
      pages.push("ellipsis-left");
    }

    // Middle pages
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Right ellipsis
    if (end < total - 2) {
      pages.push("ellipsis-right");
    }

    // Always include last page
    pages.push(total - 1);

    return pages;
  }, [preambleCount, preambleIndex]);

  const articlePagination = useMemo(() => {
    const total = articleCount;       // total pages
    const current = articleIndex;     // current page index (0-based)
    const maxVisible = 7;             // max pages to display in window
    const pages = [];

    if (total <= 1) return [];
    // if (total <= 1) return null;

    // Always include first page
    pages.push(0);

    // Case 1: if total pages ≤ maxVisible → showDelete all
    if (total <= maxVisible) {
      for (let i = 1; i < total; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Define sliding window
    let start = Math.max(1, current - 2);
    let end = Math.min(total - 2, current + 2);

    // Ensure window always has (maxVisible - 2) slots (excluding first & last)
    const windowSize = maxVisible - 2;
    if (end - start + 1 < windowSize) {
      if (current <= Math.floor(total / 2)) {
        end = Math.min(total - 2, start + windowSize - 2);
      } else {
        start = Math.max(1, end - windowSize + 1);
      }
    }

    // Left ellipsis
    if (start > 1) {
      pages.push("ellipsis-left");
    }

    // Middle pages
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Right ellipsis
    if (end < total - 2) {
      pages.push("ellipsis-right");
    }

    // Always include last page
    pages.push(total - 1);

    return pages;
  }, [articleCount, articleIndex]);

  const annexPagination = useMemo(() => {
    const total = annexCount;       // total pages
    const current = annexIndex;     // current page index (0-based)
    const maxVisible = 7;             // max pages to display in window
    const pages = [];

    if (total <= 1) return [];
    // if (total <= 1) return null;

    // Always include first page
    pages.push(0);

    // Case 1: if total pages ≤ maxVisible → showDelete all
    if (total <= maxVisible) {
      for (let i = 1; i < total; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Define sliding window
    let start = Math.max(1, current - 2);
    let end = Math.min(total - 2, current + 2);

    // Ensure window always has (maxVisible - 2) slots (excluding first & last)
    const windowSize = maxVisible - 2;
    if (end - start + 1 < windowSize) {
      if (current <= Math.floor(total / 2)) {
        end = Math.min(total - 2, start + windowSize - 2);
      } else {
        start = Math.max(1, end - windowSize + 1);
      }
    }

    // Left ellipsis
    if (start > 1) {
      pages.push("ellipsis-left");
    }

    // Middle pages
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Right ellipsis
    if (end < total - 2) {
      pages.push("ellipsis-right");
    }

    // Always include last page
    pages.push(total - 1);

    return pages;
  }, [annexCount, annexIndex]);

  const memorandumPagination = useMemo(() => {
    const total = memorandumCount;       // total pages
    const current = memorandumIndex;     // current page index (0-based)
    const maxVisible = 7;             // max pages to display in window
    const pages = [];

    if (total <= 1) return [];
    // if (total <= 1) return null;

    // Always include first page
    pages.push(0);

    // Case 1: if total pages ≤ maxVisible → showDelete all
    if (total <= maxVisible) {
      for (let i = 1; i < total; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Define sliding window
    let start = Math.max(1, current - 2);
    let end = Math.min(total - 2, current + 2);

    // Ensure window always has (maxVisible - 2) slots (excluding first & last)
    const windowSize = maxVisible - 2;
    if (end - start + 1 < windowSize) {
      if (current <= Math.floor(total / 2)) {
        end = Math.min(total - 2, start + windowSize - 2);
      } else {
        start = Math.max(1, end - windowSize + 1);
      }
    }

    // Left ellipsis
    if (start > 1) {
      pages.push("ellipsis-left");
    }

    // Middle pages
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Right ellipsis
    if (end < total - 2) {
      pages.push("ellipsis-right");
    }

    // Always include last page
    pages.push(total - 1);

    return pages;
  }, [memorandumCount, memorandumIndex]);

  function toArabicIndic(num) {

    const western = "0123456789";

    const arabic  = "٠١٢٣٤٥٦٧٨٩";
    return num.toString().replace(/[0-9]/g, d => arabic[western.indexOf(d)]);

  }

  useEffect(() => {
    const fetchJson = async () => {
      try {
        if (!state.JsonURL) return;
        // const response = await fetch("https://storage.googleapis.com/rag-legal-docs-dev/final_output_test/1759916921490.json");
        const response = await fetch(state.JsonURL);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonData = await response.json() || {};
        const documentId = jsonData.document_info?.id;
        const id = documentId ? documentId : Date.now();

        const updatedData = {
          ...jsonData,
          document_info: {
            ...jsonData.document_info,
            id,
            article_count: Array.isArray(jsonData.articles) ? jsonData.articles.length : 0,
          },
          articles: Array.isArray(jsonData.articles)
            ? [...jsonData.articles]
                .map((a) => ({
                  ...a,
                  article_number:
                    a.article_number && typeof a.article_number !== "string"
                      ? toArabicIndic(a.article_number)
                      : a.article_number,
                }))
                .sort(
                  (a, b) =>
                    (Number(a.article_number_numeric) || 0) -
                    (Number(b.article_number_numeric) || 0)
                )
            : [],
        };

        setData(updatedData);
      } catch (err) {
        console.error("Error fetching JSON:", err);
      }
    };

    fetchJson();
  }, [state.JsonURL]);

  useEffect(() => {
    dispatch(fetchUsers({ IsSystemUser: true, IsActive: true, RoleID: 118 }));

  }, [])

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <CardTitle tag="h4" className="mt-1 pb-2">{state.FileName}</CardTitle>
                <Row className="align-items-center">
                  <Col md="6">
                    <div className="d-flex gap-2 justify-content-start">
                      <Button color="secondary" onClick={() => navigate(-1)}>
                        <i className={`${i18n.language === 'en' ? "ri-arrow-left-line" : "ri-arrow-right-line"}`} />
                      </Button>
                    </div>
                  </Col>
                  <Col md="6" className="text-end">
                    <div className="d-flex gap-2 justify-content-end">
                      { ([1, 4].includes(user.RoleID)) && <>
                        <Button onClick={exportJSON}>
                          {t('Export JSON')}
                        </Button>
                        <Button color="success" onClick={() => handleSaveJson(data)} disabled={isSaving}>
                          {t('Save')}
                        </Button> 
                      </>
                      }
                      { ([1, 4, 98].includes(user.RoleID)) &&
                        <Button onClick={() => setShowConfirm(true)} disabled={isSaving}>
                          {t('Assign')}
                        </Button> 
                      }
                      {  user.RoleID == 118 &&
                        <Button color="success" onClick={() => setShowReviewed(true)} disabled={isSaving}>
                          {t('Reviewed')}
                        </Button> 
                      }
                    </div>
                  </Col>
                </Row>

                <Nav tabs style={{ marginTop: 16 }}>
                  <NavItem>
                    <NavLink
                      className={activeTab === "document" ? "active" : ""}
                      onClick={() => setActiveTab("document")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('Document')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "preamble" ? "active" : ""}
                      onClick={() => setActiveTab("preamble")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('Preamble')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "article" ? "active" : ""}
                      onClick={() => setActiveTab("article")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('Article')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "memorandum" ? "active" : ""}
                      onClick={() => setActiveTab("memorandum")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('Explanatory Memorandum')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "annexes" ? "active" : ""}
                      onClick={() => setActiveTab("annexes")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('annexes')}
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink
                      className={activeTab === "ai_explanation" ? "active" : ""}
                      onClick={() => setActiveTab("ai_explanation")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('AI Unstanding')}
                    </NavLink>
                  </NavItem> */}
                </Nav>

                <TabContent activeTab={activeTab} style={{ marginTop: 12 }}>
                  <TabPane tabId="document">
                    <Row className="justify-content-center mt-3" style={{ height: "80vh" }}>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto", // vertical scrollbar for PDF
                        }}>
                        <RecursiveEditor
                          name="document_info"
                          value={selectedDoc?.document_info}
                          path={["document_info"]}
                          onChange={onChangeValue} 
                          keys={hideFields.document_info}
                          readOnly={[98].includes(user.RoleID)}
                        />
                        {/* <Accordion open={openAccordion} toggle={toggleAccordion}>
                          <AccordionItem>
                            <AccordionHeader targetId="2">{t('Document Info')}</AccordionHeader>
                            <AccordionBody accordionId="2">
                              <RecursiveEditor
                                name="document_info"
                                value={selectedDoc?.document_info}
                                path={["document_info"]}
                                onChange={onChangeValue} 
                                keys={[1, 4, 98].includes(user.RoleID) ? hideFields.document_info : hideFields.document_info_paralegal}
                              />
                            </AccordionBody>
                          </AccordionItem>

                          <AccordionItem>
                            <AccordionHeader targetId="3">{t('Preamble')}</AccordionHeader>
                            <AccordionBody accordionId="3">
                              <RecursiveEditor
                                name="preamble"
                                value={selectedDoc?.preamble}
                                path={["preamble"]}
                                onChange={onChangeValue} 
                              />
                            </AccordionBody>
                          </AccordionItem>

                        </Accordion> */}
                      </Col>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}>
                        <iframe
                          src={state.FileURL || ''}
                          width="100%"
                          height="95%"
                          title="PDF Viewer"
                          style={{ minHeight: "570px" }}
                          ></iframe>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="preamble">
                    <Row className="justify-content-center mt-3" style={{ height: "80vh" }}>
                      <Col md={6}
                        style={{
                          height: "100%",
                          overflowY: "auto", // vertical scrollbar for PDF
                        }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{t('Preamble')}</strong>{" "}
                            <small className="text-muted">({preambleCount})</small>
                          </div>
                          <div>
                            <Button
                              size="sm"
                              color="secondary"
                              outline
                              onClick={() => {
                                // add new blank paragraph
                                const newPreamble = {
                                  ...(selectedDoc?.sections),
                                  document_preamble: [
                                    ...(selectedDoc?.sections?.document_preamble || []),
                                    {
                                      preamble_type: "",
                                      content: "",
                                      tables: null
                                    }
                                  ]
                                };
                                updateDocumentField(["sections"], newPreamble);
                                setPreambleIndex(preambleCount)
                              }}>
                              {t('Add')}
                            </Button>
                          </div>
                        </div>

                        {preambleCount === 0 ? (
                          <div style={{ marginTop: 12 }}>{t('NoPreambleAvailable')}</div>
                        ) : (
                          <>
                            <Card style={{ marginTop: 12 }}>
                              <CardBody>
                                <h6>{t('Introduction')}</h6>
                                <RecursiveEditor
                                  name="document_introduction"
                                  value={selectedDoc?.sections?.document_introduction || ''}
                                  path={["sections", "document_introduction"]}
                                  onChange={onChangeValue} 
                                  readOnly={[98].includes(user.RoleID)}
                                />

                                <RecursiveEditor
                                  name="sections"
                                  value={currentPreamble}
                                  path={["sections", "document_preamble", preambleIndex]}
                                  onChange={onChangeValue} 
                                  readOnly={[98].includes(user.RoleID)}
                                />
                              </CardBody>
                            </Card>

                            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 12 }}>
                              <Pagination>
                                <PaginationItem disabled={preambleIndex === 0}>
                                  <PaginationLink previous onClick={() => gotoPreamble(preambleIndex - 1)} />
                                </PaginationItem>

                                {preamblePagination.map((p, idx) =>
                                  p === "ellipsis-left" || p === "ellipsis-right" ? (
                                    <PaginationItem key={idx} disabled>
                                      <PaginationLink>...</PaginationLink>
                                    </PaginationItem>
                                  ) : (
                                    <PaginationItem active={p === preambleIndex} key={idx}>
                                      <PaginationLink onClick={() => gotoPreamble(p)}>
                                        {p + 1}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )
                                )}


                                <PaginationItem disabled={preambleIndex === preambleCount - 1}>
                                  <PaginationLink next onClick={() => gotoPreamble(preambleIndex + 1)} />
                                </PaginationItem>
                              </Pagination>

                              <div>
                                <Button
                                  size="sm"
                                  color="danger"
                                  outline
                                  onClick={() => {
                                    // remove current paragraph
                                    const obj = {...selectedDoc?.sections};
                                    obj.document_preamble?.splice(preambleIndex, 1);
                                    updateDocumentField(["document_preamble"], obj);
                                    gotoPreamble(Math.max(0, preambleIndex - 1));
                                  }}
                                >
                                  {t('Delete')}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </Col>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}>
                        <iframe
                          src={state.FileURL || ''}
                          width="100%"
                          height="95%"
                          title="PDF Viewer"
                          style={{ minHeight: "600px" }}
                          ></iframe>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="article">
                    <Row className="justify-content-center mt-3" style={{ height: "80vh" }}>
                      <Col md={6}
                        style={{
                          height: "100%",
                          overflowY: "auto", // vertical scrollbar for PDF
                        }}>
                        <div className="mt-2 mb-2 d-flex flex-wrap gap-2">
                          <Button
                            size="sm"
                            color={!selectedInstrumentType ? "primary" : "secondary"}
                            outline={!!selectedInstrumentType}
                            onClick={() => setSelectedInstrumentType(null)}
                          >
                            {t('All')}
                          </Button>

                          {instrumentTypes.map((type) => (
                            <Button
                              key={type}
                              size="sm"
                              color={selectedInstrumentType === type ? "primary" : "secondary"}
                              outline={selectedInstrumentType !== type}
                              onClick={() => {
                                setArticleIndex(0);
                                setSelectedInstrumentType(type);
                              }}
                              className="d-flex align-items-center p-0"
                            >
                              <span className="flex-grow-1 px-2">{type}</span>
                              <span
                                className="bg-danger d-flex align-items-center justify-content-center px-2"
                                style={{
                                  height: "100%",
                                  cursor: "pointer",
                                  borderTopRightRadius: "inherit",
                                  borderBottomRightRadius: "inherit",
                                }}
                                onClick={(e) => handleEditClick(e, type)}
                              >
                                <i className="ri-edit-2-line text-white"></i>
                              </span>
                            </Button>
                          ))}
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{t('Total Articles')}</strong>{" "}
                            <small className="text-muted">({articleCount})</small>
                          </div>
                          { !selectedInstrumentType &&
                            <div>
                              <Button
                                size="sm"
                                color="secondary"
                                outline
                                onClick={() => {
                                  // add new blank article
                                  const newArticles = 
                                    [...(selectedDoc?.articles || []), { 
                                      chunk_id: `unique_chunk_id_${Date.now()}`,
                                      chunk_type: "",
                                      article_number: "",
                                      article_number_numeric: "",
                                      document_number: "",
                                      article_status: "",
                                      group_type: [],
                                      is_source_article: "",
                                      article_title_ar: "",
                                      instrument_type: "",
                                      content: "",
                                      Replaced_info: {
                                        law_number: "",
                                        article_number: ""
                                      },
                                      article_actions: {
                                        repeals: [   
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ],
                                        replaces: [
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ],
                                        adds_new_article: [
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ],
                                        adds_paragraph: [
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ],
                                        amends_text_in: [
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ],
                                        renumbers: [
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ],
                                        renames_element: [
                                          {
                                            target_law_number: "",
                                            target_article_number: "",
                                            action_description: ""
                                          }
                                        ]
                                      },
                                      article_linking: {
                                        linked_to: [
                                          {
                                            law_number: "",
                                            article_number: "",
                                            relation_type: "",
                                            note: ""
                                          }
                                        ],
                                        referred_by: [
                                          {
                                            law_number: "",
                                            article_number: "",
                                            relation_type: "",
                                            note: ""
                                          }
                                        ],
                                        related_articles_within_same_law: [
                                          {
                                            law_number: "",
                                            article_number: "",
                                            relation_type: "",
                                            note: ""
                                          }
                                        ]
                                      },
                                      tables: [],
                                      is_source_article_text: ""
                                    }]
                                  

                                  updateDocumentField(["articles"], newArticles);
                                  // gotoArticle(articleCount + 1);
                                  setArticleIndex((selectedDoc?.articles || []).length);
                                }}
                              >
                                {t('Add')}
                              </Button>
                            </div>
                          }
                        </div>

                        {articleCount === 0 ? (
                          <div style={{ marginTop: 12 }}>{t('NoArticleAvailable')}</div>
                        ) : (
                          <>
                            <Card style={{ marginTop: 12 }}>
                              <CardBody>
                                <div className="d-flex justify-content-between align-items-center">
                                  <h6>{t('Article')} {currentArticle?.article_number}</h6>
                                </div>

                                <RecursiveEditor
                                  // name={`article_${articleIndex}`}
                                  value={currentArticle}
                                  path={["articles", articleIndex]}
                                  onChange={onChangeValue} 
                                  keys={hideFields.articles}
                                  readOnly={[98].includes(user.RoleID)}
                                />
                              </CardBody>
                            </Card>

                            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 12 }}>
                              <Pagination>
                                <PaginationItem disabled={articleIndex === 0}>
                                  <PaginationLink previous onClick={() => gotoArticle(articleIndex - 1)} />
                                </PaginationItem>

                                {articlePagination.map((p, idx) =>
                                  p === "ellipsis-left" || p === "ellipsis-right" ? (
                                    <PaginationItem key={idx} disabled>
                                      <PaginationLink>...</PaginationLink>
                                    </PaginationItem>
                                  ) : (
                                    <PaginationItem active={p === articleIndex} key={idx}>
                                      <PaginationLink onClick={() => gotoArticle(p)}>
                                        {p + 1}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )
                                )}


                                <PaginationItem disabled={articleIndex === articleCount - 1}>
                                  <PaginationLink next onClick={() => gotoArticle(articleIndex + 1)} />
                                </PaginationItem>
                              </Pagination>
                          

                              <div>
                                <Button
                                  size="sm"
                                  color="danger"
                                  outline
                                  onClick={() => {
                                    // remove current article
                                    const arr = [...selectedDoc?.articles];
                                    arr.splice(articleIndex, 1);
                                    // updateDocumentField(["articles"], arr);

                                    const updatedData = {
                                      ...selectedDoc,
                                      document_info: {
                                        ...selectedDoc.document_info,
                                        article_count: arr?.length || 0,
                                      },
                                      articles: arr
                                    };

                                    setData(updatedData);
                                    gotoArticle(Math.max(0, articleIndex - 1));
                                  }}
                                  disabled={articleCount === 0}
                                >
                                  {t('Delete')}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </Col>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}>
                        <iframe
                          src={state.FileURL || ''}
                          width="100%"
                          height="95%"
                          title="PDF Viewer"
                          style={{ minHeight: "600px" }}
                          ></iframe>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="memorandum">
                    <Row className="justify-content-center mt-3" style={{ height: "80vh" }}>
                      <Col md={6}
                        style={{
                          height: "100%",
                          overflowY: "auto", // vertical scrollbar for PDF
                        }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{t('Explanatory Memorandum')}</strong>{" "}
                            <small className="text-muted">({memorandumCount})</small>
                          </div>
                          <div>
                            <Button
                              size="sm"
                              color="secondary"
                              outline
                              onClick={() => {
                                // add new blank paragraph
                                const newMemorandum = {
                                  ...(selectedDoc?.sections || {}),
                                  document_explanatory_memorandum: [
                                    ...(selectedDoc?.sections.document_explanatory_memorandum || []),
                                    {
                                      content: '',
                                      references: []
                                    }
                                  ]
                                };
                                updateDocumentField(["sections"], newMemorandum);
                                setMemorandumIndex(memorandumCount)
                              }}>
                              {t('Add')}
                            </Button>
                          </div>
                        </div>

                        {memorandumCount === 0 ? (
                          <div style={{ marginTop: 12 }}>{t('NoExplanatoryMemorandumAvailable')}</div>
                        ) : (
                          <>
                            <Card style={{ marginTop: 12 }}>
                              <CardBody>

                                {/* <RecursiveEditor
                                  name={`title`}
                                  value={memorandum.title}
                                  path={["explanatory_memorandum", "title"]}
                                  onChange={onChangeValue} 
                                  readOnly={false}
                                /> */}

                                <RecursiveEditor
                                  name="sections"
                                  value={currentMemorandum}
                                  path={["sections", "document_explanatory_memorandum", memorandumIndex]}
                                  onChange={onChangeValue} 
                                  readOnly={[98].includes(user.RoleID)}
                                />

                              </CardBody>
                            </Card>

                            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 12 }}>
                              <Pagination>
                                <PaginationItem disabled={memorandumIndex === 0}>
                                  <PaginationLink previous onClick={() => gotoArticle(memorandumIndex - 1)} />
                                </PaginationItem>

                                {memorandumPagination.map((p, idx) =>
                                  p === "ellipsis-left" || p === "ellipsis-right" ? (
                                    <PaginationItem key={idx} disabled>
                                      <PaginationLink>...</PaginationLink>
                                    </PaginationItem>
                                  ) : (
                                    <PaginationItem active={p === memorandumIndex} key={idx}>
                                      <PaginationLink onClick={() => gotoMemorandum(p)}>
                                        {p + 1}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )
                                )}


                                <PaginationItem disabled={memorandumIndex === memorandumCount - 1}>
                                  <PaginationLink next onClick={() => gotoMemorandum(memorandumIndex + 1)} />
                                </PaginationItem>
                              </Pagination>

                              <div>
                                <Button
                                  size="sm"
                                  color="danger"
                                  outline
                                  onClick={() => {
                                    // remove current paragraph
                                    const obj = {...selectedDoc?.sections};
                                    obj.explanatory_memorandum?.splice(memorandumIndex, 1);
                                    updateDocumentField(["explanatory_memorandum"], obj);
                                    gotoMemorandum(Math.max(0, memorandumIndex - 1));
                                  }}
                                >
                                  {t('Delete')}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </Col>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}>
                        <iframe
                          src={state.FileURL || ''}
                          width="100%"
                          height="95%"
                          title="PDF Viewer"
                          style={{ minHeight: "600px" }}
                          ></iframe>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="annexes">
                    <Row className="justify-content-center mt-3" style={{ height: "80vh" }}>
                      <Col md={6}
                        style={{
                          height: "100%",
                          overflowY: "auto", // vertical scrollbar for PDF
                        }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{t('annexes')}</strong>{" "}
                            <small className="text-muted">({annexCount})</small>
                          </div>
                          <div>
                            <Button
                              size="sm"
                              color="secondary"
                              outline
                              onClick={() => {
                                // add new blank paragraph
                                const id = new Date().getTime();
                                const newAnnex = {
                                  ...(selectedDoc?.sections || {}),
                                  annexes: [
                                    ...(selectedDoc?.sections?.annexes || []),
                                    // {
                                    //   annex_info: {
                                    //     annex_id: `annex_${(selectedDoc.sections?.annexes || []).length + 1}`,
                                    //     annex_title_ar: "",
                                    //     language: "",
                                    //     pages_covered: []
                                    //   },
                                    //   information: {
                                    //     summary_ar: ""
                                    //   }
                                    // }


                                    {
                                      "annex_info": {
                                        "annex_id": `annex_${id}`,
                                        "annex_number": "",
                                        "annex_title_ar": "",
                                        "annex_type": "",
                                        "pages_covered": [],
                                        "language": "ar",
                                        "annex_status": "",
                                        "issuing_authority_ar": "",
                                        "document_reference_ar": "",
                                        "ocr_confidence_overall": "",
                                        "watermarks_detected": [],
                                        "embedding_ready_text": "",
                                        "validation": {
                                          "has_information": false,
                                          "has_articles": false,
                                          "has_tables_flat": false,
                                          "has_forms": false,
                                          "has_plots": false
                                        }
                                      },
                                      "information": {
                                        "summary_ar": "",
                                        "notes_ar": "",
                                        "page_number": "",
                                        "bbox": [],
                                        "ocr_confidence": 0
                                      },
                                      "articles": [
                                        {
                                          "article_number": "",
                                          "article_title_ar": "",
                                          "content": "",
                                          "article_status": "",
                                          "is_source_article": "",
                                          "group_type": [],
                                          "article_actions": [],
                                          "article_linking": []
                                        }
                                      ],
                                      "tables_flat": [
                                        {
                                          "table_id": `annex_${id}_table_01`,
                                          "table_title_ar": "",
                                          "page_number": 0,
                                          "ocr_confidence": 0,
                                          "table_headers_ar": [],
                                          "normalized_headers_en": [],
                                          "table_rows_ar": [],
                                          "flattened_table_data": [],
                                          "units_note_ar": "",
                                          "validation": {
                                            "headers_present": false,
                                            "row_count_ok": false
                                          }
                                        }
                                      ],
                                      "forms_flat": [
                                        {
                                          "form_id": `annex_${id}_form_01`,
                                          "form_title_ar": "",
                                          "form_sections_ar": [
                                            {
                                              "field_label": "",
                                              "field_type": "",
                                              "example_value": ""
                                            }
                                          ],
                                          "page_number": 0,
                                          "ocr_confidence": 0,
                                          "validation": {
                                            "fields_detected": true
                                          }
                                        }
                                      ],
                                      "plots": [
                                        {
                                          "plot_id": `annex_${id}_plot_01`,
                                          "plot_title_ar": "",
                                          "plot_description_ar": "",
                                          "page_number": 0,
                                          "bbox": [],
                                          "ocr_confidence": 0,
                                          "image_reference": "",
                                          "validation": {
                                            "image_found": "",
                                            "bbox_valid": ""
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                };
                                updateDocumentField(["sections"], newAnnex);
                                setAnnexIndex(annexCount)
                              }}>
                              {t('Add')}
                            </Button>
                          </div>
                        </div>

                        <div className="my-2 d-flex flex-wrap align-items-center gap-2">
                          {data.sections?.annexes?.map((p, i) => (
                            <Button
                              key={i}
                              size="sm"
                              color={annexIndex === i ? "primary" : "secondary"}
                              outline={annexIndex !== i}
                              onClick={() => {
                                gotoAnnex(i)
                              }}
                            >
                              {`${t('annexes')} ${i + 1}`}
                            </Button>
                          ))}
                        </div>

                        {annexCount === 0 ? (
                          <div style={{ marginTop: 12 }}>{t('NoAnnexesAvailable')}</div>
                        ) : (
                          <>
                            <Card style={{ marginTop: 12 }}>
                              <CardBody>
                                <RecursiveEditor
                                  name="sections"
                                  value={currentAnnex}
                                  path={["sections", "annexes", annexIndex]}
                                  onChange={onChangeValue} 
                                  keys={hideFields.annexes}
                                  readOnly={[98].includes(user.RoleID)}
                                />

                              </CardBody>
                            </Card>

                            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 12 }}>
                              <Pagination>
                                <PaginationItem disabled={annexIndex === 0}>
                                  <PaginationLink previous onClick={() => gotoAnnex(annexIndex - 1)} />
                                </PaginationItem>

                                {annexPagination.map((p, idx) =>
                                  p === "ellipsis-left" || p === "ellipsis-right" ? (
                                    <PaginationItem key={idx} disabled>
                                      <PaginationLink>...</PaginationLink>
                                    </PaginationItem>
                                  ) : (
                                    <PaginationItem active={p === annexIndex} key={idx}>
                                      <PaginationLink onClick={() => gotoAnnex(p)}>
                                        {p + 1}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )
                                )}

                                <PaginationItem disabled={annexIndex === annexCount - 1}>
                                  <PaginationLink next onClick={() => gotoAnnex(annexIndex + 1)} />
                                </PaginationItem>
                              </Pagination>

                              <div>
                                <Button
                                  size="sm"
                                  color="danger"
                                  outline
                                  onClick={() => {
                                    // remove current paragraph
                                    const obj = {...selectedDoc?.sections};
                                    obj.annexes?.splice(annexIndex, 1);
                                    updateDocumentField(["annexes"], obj);
                                    gotoAnnex(Math.max(0, annexIndex - 1));
                                  }}
                                >
                                  {t('Delete')}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </Col>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}>
                        <iframe
                          src={state.FileURL || ''}
                          width="100%"
                          height="95%"
                          title="PDF Viewer"
                          style={{ minHeight: "600px" }}
                          ></iframe>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="ai_explanation">
                    <Row className="justify-content-center mt-3" style={{ height: "80vh" }}>
                      <Col md={6}
                        style={{
                          height: "100%",
                          overflowY: "auto", // vertical scrollbar for PDF
                        }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{t('AI Unstanding')}</strong>{" "}
                          </div>
                        </div>

                        <Card style={{ marginTop: 12 }}>
                          <CardBody>
                            {/* <h6>{t('Explanatory Memorandum')} {currentMemorandum?.paragraph_number}</h6> */}

                            <RecursiveEditor
                              name={`ai_explanation`}
                              value={selectedDoc?.document_info?.ai_explanation || ''}
                              path={["document_info", "ai_explanation"]}
                              onChange={onChangeValue} 
                              readOnly={[98].includes(user.RoleID)}
                            />

                            <RecursiveEditor
                              name={`ai_correction`}
                              value={selectedDoc?.document_info?.ai_correction || ''}
                              path={["document_info", "ai_correction"]}
                              onChange={onChangeValue} 
                              readOnly={[98].includes(user.RoleID)}
                            />
                          </CardBody>
                        </Card>

                      </Col>
                      <Col md="6"
                        style={{
                          height: "100%",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}>
                        <iframe
                          src={state.FileURL || ''}
                          width="100%"
                          height="95%"
                          title="PDF Viewer"
                          style={{ minHeight: "600px" }}
                          ></iframe>
                      </Col>
                    </Row>
                  </TabPane>

                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row> 
      </Container>

      <Modal isOpen={showConfirm} centered={true} size="md">
        <ModalBody className="py-3 px-5">
          <Formik
            initialValues={{
              ParaLegalIDs: state.ParaLegalIDs || [], // store multiple IDs
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              handleSaveJson(data, false, 3);
              state.IsProcessed = true;
              state.ParaLegalIDs = values.ParaLegalIDs;
              state.Status = 3;
              dispatch(updateDocumentJson(state))
              setShowConfirm(false);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting, setFieldValue, touched, errors, isValid }) => (
              <Form>
                <div className="mt-2 text-center">
                  <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4 className="d-flex justify-content-start">
                      {t("Select paralegals")}
                    </h4>

                    {Loading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                          Loading...
                        </Spinner>
                      </div>
                    ) : (
                      <div className="text-start">
                        <Select
                          isMulti
                          name="ParaLegalIDs"
                          className={touched.ParaLegalIDs && errors.ParaLegalIDs ? 'is-invalid' : ''}
                          styles={{
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white", // text color of selected option
                            }),
                          }}
                          menuPosition="fixed"
                          options={(Users || []).map((user) => ({
                            value: user?.ID,
                            label: user?.FullName,
                          }))}
                          value={paraLegalIDs?.map((id) => {
                            const user = Users.find((u) => u.ID === id);
                            return user ? { value: user.ID, label: user.FullName } : null;
                          }).filter(Boolean)} // filter out nulls
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map((opt) => opt.value);
                            setFieldValue("ParaLegalIDs", values);
                            setParaLegalIDs(values); // keep your local state in sync if needed
                          }}
                          noOptionsMessage={() => t("NoOptions")}
                        />

                        {touched.ParaLegalIDs && errors.ParaLegalIDs && (
                          <div className="invalid-feedback d-block">
                            {errors.ParaLegalIDs}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                  <button
                    type="button"
                    className="btn w-sm btn-light"
                    onClick={() => setShowConfirm(false)}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="submit"
                    className="btn w-sm btn-danger"
                    disabled={isSubmitting || Loading || !isValid}
                  >
                    {t("Save")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>

      <Modal isOpen={showReviewed} centered={true}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>{t('areYouSure')}</h4>
              <p className="text-muted mx-4 mb-0">{t('Are you sure you want to review this document?')}</p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              data-bs-dismiss="modal"
              onClick={() => setShowReviewed(false)}
            >
              {t("Close")}
            </button>
            <button
              type="button"
              className="btn w-sm btn-danger d-flex align-items-center"
              disabled={isSaving}
              onClick={handleReviewDocument}
            >
              {t('Yes, Reviewed it')}
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* ✨ Edit Modal */}
      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} centered>
        <ModalHeader toggle={() => setIsModalOpen(false)}>
          {t('Edit Instrument Type')}
        </ModalHeader>
        <ModalBody>
          <Label className="fw-bold">{t('Instrument Type')}</Label>
          <Input
            type="text"
            value={newTypeName}
            onChange={(e) => setNewTypeName(e.target.value)}
            placeholder={t('Enter instrument type')}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            {t('Cancel')}
          </Button>
          <Button color="primary" onClick={handleEditSave}>
            {t('Save Changes')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default DocumentDetails;